@if (overlay()) {
  <div class="overlay" [style.width.%]="width()">
    <div class="center">
      {{message()}}
    </div>
  </div>
}